const ProgressBar = ({ current, total }) => {
  const percent = total ? Math.round((current / total) * 100) : 0;
  return (
    <div>
      <div className="mb-2 flex items-center justify-between text-xs uppercase tracking-[0.2em] text-white/60">
        <span>Progress</span>
        <span>
          Question {current} / {total}
        </span>
      </div>
      <div className="h-2 rounded-full bg-white/10">
        <div
          className="h-full rounded-full bg-gradient-to-r from-brand-glow via-pink-500 to-orange-400 transition-all"
          style={{ width: `${percent}%` }}
        />
      </div>
    </div>
  );
};

export default ProgressBar;
